// $(document).ready(function() {

// $('.block__review--service-content').each(function(index) {
//     var current_collection = $(this).attr('id');
//     var carousel = $('#' + current_collection + ' .block__logo--content');

//     // Accessing attributes
//     var deskValue = parseInt(carousel.attr('data-desk')); // Parse as integer
//     var tabletValue = parseInt(carousel.attr('data-tablet')); // Parse as integer
//     var mobileValue = parseInt(carousel.attr('data-mobile')); // Parse as integer

//     var totalSlides = $('#' + current_collection + ' .block__review--service-subtitle-main-inner .block__review--service-subtitle').length;
//     if (totalSlides == 0){
//       $('#' + current_collection ).hide();
//     }
//     console.log('totalSlides', totalSlides);
//     var autoplayEnabled = totalSlides > deskValue; 
//     var tabletcondition = totalSlides > tabletValue;
//     var mobilecondition = totalSlides > mobileValue;
//     console.log('autoplayEnabled', autoplayEnabled);
//     console.log('totalSlides', totalSlides); 

  
//     // Initialize the first slick slider
//     $('#' + current_collection + ' .block__logo--content').not('.slick-initialized').slick({
//         slidesToShow: deskValue,
//         slidesToScroll: 1,
//         autoplay: autoplayEnabled,
//         infinite: autoplayEnabled,
//         arrows: false,
//         centerMode: autoplayEnabled,
//          pauseOnHover:true,
//         focusOnSelect: true,
//         centerPadding: '0px',
//         asNavFor: '#' + current_collection + ' .block__review--service-subtitle-main-inner',
//         adaptiveHeight: true,
//         responsive: [ 
//             {
//                 breakpoint: 992,
//                 settings: {
//                     slidesToShow: tabletValue,
//                     slidesToScroll: 1,
//                     autoplay: tabletcondition,
//                     infinite: tabletcondition,
//                     centerMode: tabletcondition
//                 }
//             },
//             {
//                 breakpoint: 600,
//                 settings: {
//                     slidesToShow: mobileValue,
//                     slidesToScroll: 1,
//                     autoplay: mobilecondition,
//                     infinite: mobilecondition,
//                     centerMode: mobilecondition 
//                 }
//             },
//             {
//                 breakpoint: 375,
//                 settings: {
//                     slidesToShow: 2,
//                     slidesToScroll: 1,
//                     centerMode: true,
//                     infinite:true
//                 }
//             }
//         ]
//     });
 
//     // Initialize the second slick slider
//     $('#' + current_collection + ' .block__review--service-subtitle-main-inner').not('.slick-initialized').slick({
//         slidesToShow: 1,
//         autoplay: autoplayEnabled,
//         infinite: autoplayEnabled,
//         centerMode: autoplayEnabled,
//         centerPadding: '0px',
//         draggable: false,
//         pauseOnHover:true,
//         slidesToScroll: 1,
//         arrows: false,
//         focusOnSelect: false,
//         asNavFor: '#' + current_collection + ' .block__logo--content'
//     });
// });



//   $('.block__review--service--content').not('.slick-initialized').slick({
//     slidesToShow: 3,
//     slidesToScroll: 2,
//     autoplay: false,
//     infinite: true,
//     arrows: false,
//     variableWidth: false,
//     adaptiveHeight: false,
//     responsive: [{
//         breakpoint: 992,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//           centerMode: true,
//           centerPadding: '100px',
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           autoplay: true,
//           infinite: true,
//           slidesToShow: 2,
//           slidesToScroll: 1,
//           variableWidth: true,
//           centerMode: true,
//           centerPadding: '60px',
//         }
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           autoplay: true,
//           infinite: true,
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           variableWidth: true,
//           centerMode: true,
//           centerPadding: '40px',
//         }
//       },
//       {
//         breakpoint: 400,
//         settings: {
//           autoplay: true,
//           infinite: true,
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           variableWidth: true,
//           centerMode: true,
//           centerPadding: '20px',
//         }
//       }
//     ]
//   });
// });

$(document).ready(function(){
$('.block__logo--content').not('.slick-initialized').slick({
    slidesToShow:5,
    slidesToScroll:2,
    autoplay: true,
    infinite:true,    
    arrows: false,
    centerPadding: '0px',
    centerMode: true,
    focusOnSelect: true,
    asNavFor: '.block__review--service-subtitle-main-inner',
    adaptiveHeight: true,
    responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 375,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }   
  ]
  }); 

$('.block__review--service-subtitle-main-inner').not('.slick-initialized').slick({
  slidesToShow: 1,
  autoplay: true,
  infinite:true,  
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.block__logo--content'
});


  $('.block__review--service--content').not('.slick-initialized').slick({
    slidesToShow:3,
    slidesToScroll:2,
    autoplay: false,
    infinite:false,    
    arrows: false,
    variableWidth: false,
    adaptiveHeight: false,
    responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '100px',
      }
    },
    {
      breakpoint: 768,
      settings: {
        autoplay:true,
        infinite:true,
        slidesToShow:2,
        slidesToScroll: 1,
         variableWidth: true,
        centerMode: true,        
        centerPadding: '60px',
      }
    },
       {
      breakpoint: 600,
      settings: {
        autoplay:true,
        infinite:true,
        slidesToShow:1,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        centerPadding: '40px',
      }
    },
       {
      breakpoint: 400,
      settings: {
        autoplay:true,
        infinite:true,
        slidesToShow:1,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        centerPadding: '20px',
      }
    } 
  ]
  }); 
}); 


$(document).on("mouseover" , ".block__review--service-wrapper .slick-initialized" , function(){
  $(".slick-slider").slick('slickPause');
})
$(document).on("mouseout" , ".block__review--service-wrapper .slick-slider" , function(){
  $(this).slick('slickPlay')
})

